import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    // API call placeholder
  };

  return (
    <div className="bg-main-background-color w-full flex justify-center py-8">
      <div className="flex flex-col max-w-7xl w-full px-4">
        {/* Main heading */}
        <h1 className="text-5xl tracking-wide mb-16">
          {t('contact.heading')} <br />
          {t('contact.companyName')}
        </h1>

        {/* Map Embed */}
        <div className="w-full rounded-lg">
          <iframe
            title={t('contact.map.iframeTitle')}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d57982.80521197811!2d46.586770548632806!3d24.72944380000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e2f1d4fc80b7ed5%3A0x72ed83e367cf528!2sTatweer%20Towers!5e0!3m2!1sen!2sin!4v1735058783744!5m2!1sen!2sin"
            className="w-full rounded-lg"
            height="400"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        {/* Horizontal Line */}
        <div className="h-[0.1em] w-full bg-black my-8"></div>

        {/* Important info */}
        <div className="w-full grid grid-rows-3 lg:grid-cols-3 lg:grid-rows-1 mb-8">
          <div className="pb-4">
            <p>{t('contact.address.line1')}</p>
            <p>{t('contact.address.line2')}</p>
            <p>{t('contact.address.line3')}</p>
          </div>
          <div className="flex flex-col w-full justify-center items-start lg:items-center text-left pb-4">
            <div className="md:w-3/5 max-w-fit">
              <p dir='ltr' >+966 11 123 4567</p>
              <p dir='ltr'>{t('contact.email')}</p>
            </div>
          </div>
          <div className="flex flex-col w-full justify-center items-start  lg:items-center text-left">
            <div className="md:w-2/5 max-w-fit">
              <p>{t('contact.socialLinks.linkedin')}</p>
              <p>{t('contact.socialLinks.instagram')}</p>
              <p>{t('contact.socialLinks.facebook')}</p>
            </div>
          </div>
        </div>

        {/* Contact Box */}
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 p-8 bg-blue-tint rounded-lg">
          <div className="w-full text-white pb-4">
            <h1 className="w-full text-4xl mb-4">{t('contact.form.header')}</h1>
            <p className="w-full md:w-3/4">{t('contact.form.description')}</p>
          </div>
          <div className="w-full">
            <form onSubmit={handleSubmit}>
              {/* Name Input */}
              <div className="mb-4">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  className="w-full text-white bg-blue-tint px-2 border-b-2 border-white focus:outline-none"
                  placeholder={t('contact.form.fields.name')}
                  required
                  style={{ backgroundColor: 'transparent' }}
                />
              </div>

              {/* Email and Phone Inputs */}
              <div className="flex flex-col md:flex-row gap-4 mb-4">
                <div className="w-full md:w-1/2">
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full text-white bg-blue-tint px-2 border-b-2 border-white focus:outline-none"
                    placeholder={t('contact.form.fields.email')}
                    required
                    style={{ backgroundColor: 'transparent' }}
                  />
                </div>
                <div className="w-full md:w-1/2">
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full text-white bg-blue-tint px-2 border-b-2 border-white focus:outline-none"
                    placeholder={t('contact.form.fields.phone')}
                    style={{ backgroundColor: 'transparent' }}
                  />
                </div>
              </div>

              {/* Message Input */}
              <div className="mb-4">
                <label htmlFor="message" className="py-2 text-white">{t('contact.form.fields.message')}</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleInputChange}
                  className="w-full text-white bg-blue-tint px-2 border-b-2 border-white focus:outline-none"
                  rows="6"
                  required
                  style={{ backgroundColor: 'transparent' }}
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="w-full flex items-center justify-end">
                <button
                  type="submit"
                  className="text-white py-2 px-4 rounded-lg border border-white
                  transition duration-200 hover:bg-white hover:text-blue-tint"
                >
                  {t('contact.form.button')}
                </button>
              </div>
            </form>

            {formSubmitted && (
              <div className="text-white mt-4 text-center">
                <p>{t('contact.form.success')}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
